import { Box } from "@mui/system";
import { useTranslation } from "react-i18next";
import styles from "./Deleted.module.scss";

import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { useContext } from "react";
import WorkflowContext from "../../context/WorkflowContext";

const Deleted: React.FC = () => {
  const { currentWorkflow } = useContext(WorkflowContext);
  const { t } = useTranslation();

  return (
    <Box className={styles.deleted}>
      <HighlightOffIcon />
      <p>
        {t("publication")}
        <em>{currentWorkflow?.ticketNumber}</em>
        {t("wasSuccessfulDeleted")}
      </p>
    </Box>
  );
};

export default Deleted;
